import { useQuery } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { emailApi } from '../api/emailApi';

export function useEmailMessages(filters?: {
  needs_review?: boolean;
  status?: string;
  tag?: string;
  search?: string;
  sort?: string;
}) {
  return useQuery({
    queryKey: keys.email.messages(filters),
    queryFn: ({ signal }) => emailApi.getMessages(filters, { signal }),
    staleTime: 30_000,
    refetchInterval: 30_000,
  });
}

export { useMarkNoReply } from './useEmailMutations';
